/** Collapse duration for assessment section cards (ms). Next-button scroll runs shortly after this. */
export const ASSESSMENT_SECTION_COLLAPSE_MS = 450;
